

































import { Component, Mixins } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import AuthQuery from '~/mixins/AuthQuery';
import { INetworkNotifications } from '~/types/notification';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';
import { twoFaErrorCodes } from '~/utils/errorCodes';
import { TwoFaCheckpoint } from '~/types/two-fa-checkpoints';

@Component({ components: { TwoFactorAuthInputPrompt } })
export default class NotificationSettings extends Mixins(AuthQuery) {
  @State(profile => profile.user.networkNotifications, { namespace: 'profile' })
  readonly networkNotifications!: INetworkNotifications;

  @Action('updateUser', { namespace: 'profile' })
  private updateUser!: (args: any) => void;

  get nodesOffline(): boolean {
    // must explicity be false to be disabled.
    const nodesOffline = this.networkNotifications.nodesOffline;
    if (nodesOffline || nodesOffline === undefined) return true;
    else return false;
  }

  set nodesOffline(value: boolean) {
    this.doAuthQuery(async totpToken => {
      await this.updateUser({
        networkNotifications: { nodesOffline: value },
        totpToken,
        rethrowErrorCodes: twoFaErrorCodes,
      });
    }, TwoFaCheckpoint.accountModifications);
  }
}
